import React from 'react';
import PropTypes from 'prop-types';
import { Translate, withLocalize } from 'react-localize-redux';
import css from './StatusLabel.css';

const StatusLabel = ({ label, status }) => {
    return (
        <div className={`${css.onOffIndication} ${status === 'active' ? css.active : css.activityDot}`}>
            <div className={`${css.activityDot} ${status === 'active' ? css.active : ''}`} />
            <Translate id={label} />
        </div>
    );
};

StatusLabel.propTypes = {
    label: PropTypes.string,
    status: PropTypes.oneOf(['active', 'disabled', 'pending']),
};

export default withLocalize(StatusLabel);
